var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-file"
  }, [_c('b-modal', {
    attrs: {
      "id": "repInfoRequestCancelModal",
      "centered": "",
      "size": "md",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.getData
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "repInfoRequestCancelModal-header text-center"
        }, [_c('h4', [_vm._v("Cancel Request")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "repInfoRequestCancelModal-form"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          ref: "repInfoRequestContainer",
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.cancelRequest);
            }
          }
        }, [_c('input-textarea', {
          attrs: {
            "rules": {
              required: false
            },
            "labelFor": "reason",
            "labelName": "Reason",
            "inputName": "reason",
            "vmodel": _vm.form.cancel_reason,
            "formGroupClass": "form-group mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "cancel_reason", $event);
            }
          }
        }), _c('div', {
          staticClass: "col-md-12"
        }, [_c('b-button', {
          staticClass: "univ-btnEdit",
          attrs: {
            "type": "submit",
            "disabled": _vm.isCancel
          }
        }, [[_vm._v(" " + _vm._s(_vm.isCancel ? "Canceling Request ..." : "Cancel Request") + " ")]], 2)], 1)], 1)];
      }
    }])
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }